<template>
  <div id="cardView" class="container-fluid">
    <!-- <h2>Patient CardView</h2> -->

    <div :class="userStore.borderClass" style="height: 100%; overflow-y: auto">
      <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->
      <!-- {{ props.records.name }} -->
      <!-- <h4>Widget Summary Card View</h4> -->
      <DxCardView
        id="card-view"
        class="widgetSummaryCardView"
        cards-per-row="6"
        :card-min-width="120"
        :data-source="props.records"
        key-expr="ID"
        :allow-column-reordering="true"
        card-content-template="cardTemplateNew"
        @selection-changed="onSelectionChanged"
        @card-click="onCardClick"
      >
        <DxHeaderFilter :visible="true" />

        <DxSearchPanel :visible="true" />
        <!-- <DxSelection mode="single" /> -->
        <DxPaging :page-size="50" />
        <DxPager :show-info="true" :show-navigation-buttons="true" :show-page-size-selector="true" />
        <!--
        <DxColumn data-field="firstName" :allow-hiding="false" />
        <DxColumn data-field="lastName" />
        <DxColumn data-field="dateOfBirth" />
       <DxColumn data-field="dateOfBirth" /> -->
        <!--    <DxColumn data-field="priority" caption="Priority" field-value-template="priorityTemplate" />

        <template
          #priorityTemplate="{
            data: {
              field: { value },
            },
          }"
        >
          xxxxxxxxx {{ value }}
        </template> -->

        <template
          #cardTemplateNew="{
            data: {
              card: { data },
            },
          }"
        >
          <!-- {{ data }} -->
          <WidgetPrmaryCardBody :record="data" />
        </template>
      </DxCardView>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, toRaw } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();
import { useUsersPatientsStore } from "@/stores/usersPatientStore";
const usersPatStore = useUsersPatientsStore();

import { useRouter } from "vue-router";
// & ROUTER
const router = useRouter();

// import "devextreme/dist/css/dx.dark.compact.css";
import DxCardView, { DxColumn, DxHeaderFilter, DxSearchPanel, DxSelection, DxPaging, DxPager, DxColumnChooser, DxPosition } from "devextreme-vue/card-view";

import WidgetPrmaryCardBody from "./WidgetPrmaryCardBody.vue";

// & PROPS
const props = defineProps({
  records: {
    type: Array,
    required: true,
    default: () => [],
  },
  fields: {
    type: Array,
    required: false,
    default: () => [],
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);

const canAddCurrentPatient = computed(() => {
  return patientStore.currentPatientId && !patientStore.patientIDStartList.includes(patientStore.currentPatientId);
});

function addCurrentPatientToStartList() {
  const id = patientStore.currentPatientId;
  if (id && !patientStore.patientIDStartList.includes(id)) {
    patientStore.patientIDStartList.push(id);
    addPatientMessage.value = `Patient ID ${id} added!`;
    setTimeout(() => (addPatientMessage.value = ""), 2000);
  }
}
function onSelectionChanged(e) {
  // console.clear();
  // console.log("Selection changed:", e);
  // handle selection logic here
  // console.log("E  selectedCardsData");
  // console.log(
  //   e.selectedCardsData[0].lastName +
  //     " " +
  //     e.selectedCardsData[0].firstName +
  //     " " +
  //     e.selectedCardsData[0].middleName +
  //     " " +
  //     e.selectedCardsData[0].patientID +
  //     " " +
  //     e.selectedCardsData[0].dateOfBirth
  // );

  // console.log(e.selectedCardsData[0]);

  // router.push("/patient/" + e.selectedCardsData[0].personId);
}

function onCardClick(e) {
  console.clear();
  // console.log("onCardClick :", e);

  // Add the patient ID to the start list if it's not already there
  const patientId = Number(e.card.data.personId);
  // * If not in the list, add it

  if (patientId && !usersPatStore.patientIDStartList.includes(patientId)) {
    usersPatStore.patientIDStartList.push(patientId);
    // console.log(` WIDGET PRIMARY CARD VIEW       usersPatStore   Patient ID ${patientId} added to start list`);
    // console.log(`    Added  ID ${patientId}`);
  }
  // * If the patient ID is already in the list, remove it
  else if (patientId && usersPatStore.patientIDStartList.includes(patientId)) {
    const existingIndex = usersPatStore.patientIDStartList.indexOf(patientId);
    usersPatStore.patientIDStartList.splice(existingIndex, 1);
    // console.log(`    Removed ID ${patientId}`);
  }
}

onMounted(() => {
  // console.log("onMounted() :      Patient Card View >>>>");
  // console.log("props : ");
  // console.log(props);
  // console.log(" prop   records ");
  // console.log(props.records);
  // console.log("*******************************************************************");
});
</script>

<style lang="scss" scoped>
#cardView {
  //  background: #6e796f;
  //  color: white;
  // background-image: url('/content/images/innovare-logo.jpg');
  // background-repeat: no-repeat;
  // background-size: cover;
  // height: 500px;
  // height: 16vh;
  overflow: auto;
  text-align: center;
}
/* Hover effect for DxCardView cards */
:deep(.dx-cardview-card:hover) {
  background-color: #0a7bfc7f; /* light yellow */
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

:deep(.dx-cardview-card-content) {
  background: yellow;
  padding: 7px;
  display: contents;
}
</style>
